module.exports = __webpack_public_path__ + "img/createSurveyTest.432cfafa.gif";